// extracted by mini-css-extract-plugin
export var multimediaImage = "styles-module--multimediaImage--92AGa";